export const COMMON_FILTER_KEYS =  {
    START_DATE: "startDate",
    END_DATE: "endDate",
    PREV_START_DATE: "prevStartDate",
    PREV_END_DATE: "prevEndDate",
    CURRENT_SINGLE_DATE: "currentSingleDate",
    PREV_SINGLE_DATE: "prevSingleDate",
    BRAND: "brand",
    COMPANY: "company",
    CURRENT_PERIOD: "currentPeriod",
    CATEGORY: "category",
    GOOGLE_CATEGORY: "googleCategory",
    COUNTRY: "country",
    SECTION_CATEGORY: "sectionCategory",
    SKU: "sku",
    SKU_GROUP: "skuGroup",
    RETAILER: "retailer",
    KPI_PRICE: "kpiPrice",
    GROUPED_BY: "groupedBy",
    INCLUDE_SHIPPING_PRICE: "includeShippingPrice",
    BUY_BOX: "buyBox",
    AUTHORIZED_SELLER: "authorizedSeller",
    KEYWORD: "keyword",
    DASHBOARD: "dashboard",
    CATEGORY_FAKE: "categoryFake",
    SELLERS: "sellers",
    VISION: "vision",
    VALIDATED: "validated",
    NORMALIZED: "normalized",
    SPLIT_KPI: "splitKpi",
    METRIC: "metric",
    LOST_BUY_BOX_REASON: "lostBuyBoxReason",
    PRODUCTS_IN_STOCK: "productsInStock",
    KPI_TYPE: "kpiType",
    TAGS: "tags",
    PAGE_CATEGORY: "pageCategory",
    PAGE_PRODUCT_TYPE: "pageProductType",
    RESOURCE_TYPE: "resourceType",
    DEVICE_TYPE: "deviceType"
}